//styles
import { ReviewsWrapper as Wrapper } from "./reviews.styles";

const Reviews = () => {
  return <div />;
};

export default Reviews;
